import Api from '../api'

let api = new Api()

export default class AllocationStore {
  state = {}

  constructor(api) {
    this.api = api
  }

  async getPurchaseOrderItems(allocationParameter) {
    let response = await this.api.post(api.GetPurchaseOrderItems(), {
      allocationParameter
    })
    return response.data
  }
}




// WEBPACK FOOTER //
// ./src/components/_modules/I2P/AllocationsSection/AllocationsStore.js